import {
  FunctionBlockConfigEvent,
  FunctionBlockLogResultEvent,
  FunctionBlockStateEvent,
  NetworkDeviceStateEvent,
} from '@ubie/mqttcommunication';
import { Observable, share, Subject } from 'rxjs';
import { UbieState } from '../interfaces';
import { NetworkDeviceCommunicationResult } from './NetworkDeviceCommunicationResult';

export class FunctionBlockCommunicationResult extends NetworkDeviceCommunicationResult {
  constructor(
    ubieDeviceCom: Subject<UbieState>,
    networkDeviceCom: Subject<NetworkDeviceStateEvent>,
    functionBlockCom$: Subject<FunctionBlockStateEvent>,
    functionBlockConfigCom$: Subject<FunctionBlockConfigEvent>,
    functionBlockLogResultCom$: Subject<FunctionBlockLogResultEvent>,
    functionBlockMessageCom$: Subject<any>,
  ) {
    super(ubieDeviceCom, networkDeviceCom);

    this.state$ = functionBlockCom$.asObservable().pipe(share());

    this.config$ = functionBlockConfigCom$.asObservable().pipe(share());

    this.logResult$ = functionBlockLogResultCom$.asObservable().pipe(share());

    this.message$ = functionBlockMessageCom$.asObservable().pipe(share());
  }

  readonly state$: Observable<FunctionBlockStateEvent>;

  readonly config$: Observable<FunctionBlockConfigEvent>;

  readonly logResult$: Observable<FunctionBlockLogResultEvent>;

  readonly message$: Observable<any>;
}
